import React from 'react';
import { FacetClickSource, FilterFacetOption } from '../Filter.types';
import { CheckboxV2, Flex } from '@withjoy/joykit';
import { useActivePrintFiltersVar } from '../../../utils/activePrintFiltersCache';

export const CHECKBOX_STYLE_OVERRIDES = {
  Root: {
    props: {
      width: '100%',
    },
  },
  Label: { props: { typographyVariant: 'button1' } },
};

interface ListCheckboxRowProps extends FilterFacetOption {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

export const getCheckboxInputProps = (compositeCode: string, source: FacetClickSource) => ({
  ['data-item-id']: compositeCode,
  ['data-source']: source,
});

export const ListCheckboxRow = (props: ListCheckboxRowProps) => {
  const { compositeCode, label, onChange, matchingItemCount } = props;
  const activePrintFilters = useActivePrintFiltersVar();

  if (!matchingItemCount) return null;

  return (
    <Flex height={8}>
      <CheckboxV2
        overrides={{
          ...CHECKBOX_STYLE_OVERRIDES,
          Input: {
            props: getCheckboxInputProps(compositeCode, 'desktopDropdown'),
          },
        }}
        isChecked={activePrintFilters.has(compositeCode)}
        onChange={onChange}
      >
        {label} ({matchingItemCount})
      </CheckboxV2>
    </Flex>
  );
};
